import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import React, { useState } from "react";
import { Col, FormControl, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import upload from "../../Assets/Images/pickImage.svg";
import linkurl from "../../Assets/Images/linkurl.svg";

import { useDispatch, useSelector } from "react-redux";
import {
  setBatchUrlImage,
  setImageData,
  setImageUrl,
  setLoader,
} from "../../Redux/MainImage/imageSlice";
import { setItem } from "../../Redux/WaterMarks/wateramarks";

import { piexif } from "piexifjs";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../../Assets/Styles/pages/uploadImage.scss";
import { setExtension } from "../../Redux/DownloadSlice/downloadSlice";
import {
  setBatchDownload,
  setCreate_Template,
  setDiscarded,
  setEdit_Template,
} from "../../Redux/UserSlice/userSlice";
import CancelButton from "../Cancel_button/Cancel_button";
import { CircularProgress } from "@mui/material";
import helper_functions from "../../Config/helper_functions";

import Tiff from "tiff.js";
const UploadImage = ({ open, parent, setActive, multiple, handleClean }) => {
  const [loader, setLocalLoader] = useState("");
  const { t } = useTranslation();
  //reading main image from store
  const userSliceState = useSelector((state) => state["userSlice"]);
  const mainImageState = useSelector((state) => state["mainImage"]);
  const image = mainImageState.url;
  const dispatch = useDispatch();
  const history = useHistory();
  const [value, setValue] = useState("");
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnlineStatus = () => setIsOnline(true);
    const handleOfflineStatus = () => setIsOnline(false);

    window.addEventListener("online", handleOnlineStatus);
    window.addEventListener("offline", handleOfflineStatus);

    return () => {
      window.removeEventListener("online", handleOnlineStatus);
      window.removeEventListener("offline", handleOfflineStatus);
    };
  }, [navigator.onLine]);

  const handleImageLoad = () => {
    setLocalLoader("link");
    setTimeout(() => {
      if (!value) {
        alert(t("ImageUrlError"));
        setLocalLoader("");
        return;
      }

      // URL validation regex
      const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;

      // Check if the input value matches the URL pattern
      if (!urlRegex.test(value)) {
        alert("The URL appears to be invalid!");
        setLocalLoader("");
        return;
      }

      const imageFormats = ["image/jpeg", "image/png", "image/svg+xml"];

      try {
        fetch(value)
          .then((response) => {
            // Check if the response status indicates success (200 OK)
            if (!response) {
              throw new Error("No accessable image found at this URL.");
            }
            return response.blob();
          })
          .then((blob) => {
            // Check if the image's MIME type is in the list of allowed formats
            if (!imageFormats.includes(blob.type.split("_").pop())) {
              throw new Error(
                "Invalid image format. Only JPEG, PNG, GIF, and WebP are supported."
              );
            }
            ImportImage(blob, "", blob.type.split("/")[1]);
          })
          .catch((error) => {
            console.error(error);
            setValue("");
            alert("Error loading the image: " + error.message);
          });
      } catch (error) {
        console.error(error);
        setValue("");
        alert("Error loading the image: " + error.message);
      }
      setLocalLoader("");
    }, 1000);
  };

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  // Next page on state change
  useEffect(() => {
    if (parent === true && image != null) history.push("/edit");
  }, [mainImageState.url, history, image, parent]);

  //setting the main parent image to redux store
  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const onFileChange = async (event) => {
    setLocalLoader("file");
    var files = event.target.files;

    if (!multiple) {
      // Update the state for main image or watermark image
      let file = files[0];
      let ext = file.name;
      ext = helper_functions.isImageExtension(ext);

      // ext = ext.type.toString().split('/')[1]
      if (!ext) {
        alert(t("NotSuportedFile"));
      } else {
        if (ext === "tiff") {
          try {
            file = await convertTiffToJpeg(file);
            // Use the JPEG Blob file as needed
          } catch (error) {
            console.error("error", error);
          }
        }
        // const metadata = await exifr.parse(event.target.files[0]);

        const base64 = await convertBase64(file);

        var exifObj;
        try {
          exifObj = piexif.load(base64);
        } catch (error) {
          console.log("No metaData error: ", error);
        }
        if (ext === "svg") {
          ext = "png";
          ImportImage(file, exifObj, ext);
        } else if (ext === "gif") {
          const image = new window.Image();
          image.src = base64;
          image.onload = async () => {
            var img = await helper_functions.resizeFile(
              base64,
              image.width,
              image.height,
              "",
              100
            );
            file = await helper_functions.dataURLtoFile(img);
            ext = "jpeg";
          };
        } else ImportImage(file, exifObj, ext);
      }
    } else if (multiple) {
      let numFiles = 0;
      // setNumImages(numFiles);
      var id1 = userSliceState.current_TemplateID.landcsapeTemp;
      var id2 = userSliceState.current_TemplateID.portraitTemp;

      for (let i = files.length - 1; i >= 0; i--) {
        let file = files[i];
        let ext = file.name;
        // ext = ext.type.toString().split('/')[1];
        ext = helper_functions.isImageExtension(ext);
        if (ext) {
          if (ext === "tiff") {
            try {
              file = await convertTiffToJpeg(file);
            } catch (error) {
              console.error("error", error);
            }
          }
          numFiles++;
          const base64 = await convertBase64(file);

          // var exifObj;
          try {
            exifObj = piexif.load(base64);
          } catch (error) {
            // Handle error
          }

          dispatch(setExtension(ext)); //
          if (ext === "svg") {
            ext = "1";
          }
          if (ext === "gif") {
            const image = new window.Image();
            image.src = base64;
            image.onload = async () => {
              var img = await helper_functions.resizeFile(
                base64,
                image.width,
                image.height,
                "",
                100
              );
              var fileNew = await helper_functions.dataURLtoFile(img);

              ext = "jpeg";
              dispatch(
                setImageData({
                  url: URL.createObjectURL(fileNew),
                  name: event.target.files[i].name,
                  metadata: JSON.stringify(exifObj),
                  landcsapeTemp: id1,
                  portraitTemp: id2,
                  extension: ext,
                })
              );
            };
          } else {
            dispatch(
              setImageData({
                url: URL.createObjectURL(file),
                name: event.target.files[i].name,
                metadata: JSON.stringify(exifObj),
                landcsapeTemp: id1,
                portraitTemp: id2,
                extension: ext,
              })
            );
          }
        } else {
          dispatch(setDiscarded(true));
        }
      }
      if (numFiles) dispatch(setBatchUrlImage(0));
    }

    if (userSliceState.edit_Template) {
      Promise.all([
        dispatch(setEdit_Template(false)),
        dispatch(setCreate_Template(true)),
      ]);
    }
    // dispatch(setLoader(true))
    setLocalLoader("");
  };

  const convertTiffToJpeg = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const tiffData = new Uint8Array(reader.result);

        const tiff = new Tiff({ buffer: tiffData });
        const imageData = tiff.toCanvas().toDataURL("image/jpeg");
        fetch(imageData)
          .then((res) => res.blob())
          .then((blob) => {
            resolve(blob);
          })
          .catch((error) => {
            console.log("Tiff to jpeg error: ", error);
            reject(error);
          });
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsArrayBuffer(file);
    });
  };

  const ImportImage = (file, exifObj, ext) => {
    dispatch(setLoader(true));
    if (isOnline) {
      if (parent === true) {
        dispatch(setExtension(ext));
        dispatch(setBatchDownload(false));
        dispatch(
          setImageUrl({
            url: URL.createObjectURL(file),
            name: file.name,
            metadata: JSON.stringify(exifObj),
          })
        );
        setLocalLoader("");
      } else if (parent === false && mainImageState.url) {
        let logo = URL.createObjectURL(file);
        if (logo !== null) {
          handleClean();
          dispatch(
            setItem({
              type: "image",
              property: "image",
              id: Date.now(),
              x: 50,
              y: 50,
              deg: 0,
              scaleX: 0.25,
              scaleY: 0.25,
              src: file,
              opacity: 1,
              src_type: file.type,
              name: file.name,
              size: file.size,
            })
          );
          setActive("image");
        }
      }
    }
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        handleClean();
        if (!parent) setActive("");
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 800,
      }}
    >
      <Fade in={open}>
        <Row className="model uploadModal m-0">
          <CancelButton close={() => handleClean()} />
          <Col className="right mt-5 pt-2">
            <img className="uploadLink" src={upload} alt={upload} />
            <Row className="text_18 mt-2 productSansBold">
              {t("upload.Select")}
            </Row>
            <Row className="text_15 mb-3 text-center productSansLight mt-2 mb-2">
              {t("upload.SelectDisc")}
            </Row>
            <input
              type="file"
              id="files"
              className="hidden"
              onChange={onFileChange}
              accept="image/*"
              multiple={multiple}
            />
            <label
              htmlFor="files"
              className={` ${loader === "file" && "loaderOpacity"} ${
                userSliceState.batchImages && "mb-5"
              } upload_label productSansLight pointer text_center text_15`}
            >
              {loader === "file" ? (
                <CircularProgress className="themeColor signInLoader" />
              ) : userSliceState.batchImages ? (
                "Upload Images"
              ) : (
                t("UploadImage")
              )}
            </label>
          </Col>
          {!userSliceState.batchImages && (
            <>
              <Row className="w-100 m-0 my-2 py-2 d-flex align-items-center justify-content-center">
                <div className="borderUpload w_40"></div>
                <div className="productSansLight w_10 text_16 text-center p-0 mx-2">
                  {" "}
                  OR{" "}
                </div>
                <div className="borderUpload w_40"></div>
              </Row>
              <Col className="right px-0 mb-3">
                <img className="uploadLink" src={linkurl} alt={linkurl} />
                <Row className="text_18 productSansBold mt-2">
                  {t("EnterUrl")}
                </Row>
                <Row className="text_15 productSansLight  text-wrap w_83_xl d-flex justify-content-center text-center mt-2 mb-2">
                  {t("EnterUrlDisc")}
                </Row>{" "}
                {/* ask mazhar bhae  */}
                <Row className="w_83_xl w-100 my- mt-1">
                  <FormControl
                    required
                    className="bg_link py-2 productSansLight text_14 mb-3"
                    type="text"
                    placeholder="http://www.example.com/examplefile"
                    value={value}
                    onChange={handleChange}
                  />
                </Row>
                <label
                  onClick={handleImageLoad}
                  className={` ${
                    loader === "link" && "loaderOpacity"
                  } upload_label productSansLight pointer text_center text_15 mt-2 mb-4`}
                >
                  {loader === "link" ? (
                    <CircularProgress className="themeColor signInLoader" />
                  ) : (
                    t("AddUrl")
                  )}
                </label>
              </Col>
            </>
          )}
        </Row>
      </Fade>
    </Modal>
  );
};

export default UploadImage;
